import { render } from "./AgenteConteo.vue?vue&type=template&id=2cb2dc5e&scoped=true"
import script from "./AgenteConteo.vue?vue&type=script&lang=ts"
export * from "./AgenteConteo.vue?vue&type=script&lang=ts"

import "./AgenteConteo.vue?vue&type=style&index=0&id=2cb2dc5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cb2dc5e"

export default script